// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","container":"Header_container__TsUVY","header":"Header_header__OKWO7","navigation":"Header_navigation__5VNpu"};